import Icon from '@ant-design/icons/lib/components/Icon';
import {
  cardIcon,
  creditAmex,
  creditCardGeneral,
  creditCardVisa,
  creditMasterCard
} from '@tools/ui/assets';
import {
  CardAccount,
  CardAccount as CardAccounts,
  Maybe
} from '@tools/ui/types/generated/graphql';

export const extractNetworkFromCard = (
  cardAccount?: Maybe<CardAccount>
): string | undefined => {
  const card = cardAccount || ({} as CardAccounts);
  return card.network?.toLowerCase();
};

export const buildIconAndNameFromNetwork = (
  network: string | undefined,
  tooltipText: string | undefined = ''
): { icon: typeof Icon; tooltip: string } => {
  let icon: typeof Icon;
  let tooltip = tooltipText;
  if (network?.includes('visa')) {
    icon = creditCardVisa as typeof Icon;
    tooltip = `Visa ${tooltip}`;
  } else if (network?.includes('mastercard')) {
    icon = creditMasterCard as typeof Icon;
    tooltip = `Mastercard ${tooltip}`;
  } else if (network?.includes('amex')) {
    icon = creditAmex as typeof Icon;
    tooltip = `Amex ${tooltip}`;
  } else if (network?.includes('discover')) {
    icon = creditCardGeneral as typeof Icon;
    tooltip = `Discover ${tooltip}`;
  } else if (network?.includes('debit')) {
    icon = cardIcon as typeof Icon;
    tooltip = `Debit card ${tooltip}`;
  } else {
    icon = creditCardGeneral as typeof Icon;
    tooltip = network + tooltip;
  }

  return { icon, tooltip };
};
